import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

const ArrowIcon = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="26.05px"
        height="15.85px"
        viewBox="0 0 26.05 15.85"
        xmlSpace="preserve"
        className={className}
    >
        <path
            fill={color}
            d="M15.62,15.85v-2.48H4.97c-1.67,0-2.91-0.46-3.73-1.37C0.41,11.08,0,9.71,0,7.89L0,0l1.29,0v0.12
		c0,1.61,0.28,2.71,0.83,3.31c0.55,0.6,1.56,0.9,3.03,0.9h10.48V1.81l10.43,7.02L15.62,15.85z"
        />
    </svg>
);

ArrowIcon.propTypes = propTypes;
ArrowIcon.defaultProps = defaultProps;

export default ArrowIcon;
